import React from 'react';
import './styles.scss';
import { MyModal } from 'components/Atoms';
import { ListDemographic } from 'components/Organisms';

const ModalListDemographic = ({
  visible,
  onClose,
  demographics = [],
  serviceList,
  title,
}) => {
  return (
    <MyModal
      className="modal-list-demographic"
      visible={visible}
      onClose={onClose}
      title={title}
      width={1280}
    >
      <ListDemographic
        showHeader={false}
        demographics={demographics}
        isModal={true}
        showLimit={demographics?.length}
        colsInRow={2}
        serviceList={serviceList}
      />
    </MyModal>
  );
};

export default ModalListDemographic;
